import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth/auth.service';
import { APP_NAME } from '../utils';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config: any;
  private appName = inject(APP_NAME);

  constructor(private http: HttpClient, private authService: AuthService) {}

  loadConfig(): Promise<void> {
    const email = this.authService.currentUserValue?.email || null; 
    // 
    const org = email ? this.getOrgFromEmail(email) : this.getOrgFromSubdomain();
    const fallback = this.appName.toLowerCase();
    const configUrl = `/assets/config/${org || fallback}.json`;

    // console.log('Loading app config for:', {
    //   appName: this.appName,
    //   email,
    //   org,
    //   configUrl
    // });


    return this.http.get(configUrl)
      .toPromise()
      .then(config => { this.config = config; return; })
      .catch(error => {
        console.warn(`Failed to load config for org: ${org}`, error);
        this.config = {};
        return;
      });
  }

  private getOrgFromEmail(email: string): string {
    try {
      const domain = email.split('@')[1];
      return domain?.split('.')[0].toLowerCase() || 'default';
    } catch {
      return 'default';
    }
  }

  private getOrgFromSubdomain(): string {
    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];

    if (hostname === 'localhost' || hostname.startsWith('127.')) {
      return 'default';
    }

    return subdomain.toLowerCase() || 'default';
  }

  getConfig(): any {
    return this.config;
  }

  get brandCode(): number {
    return this.config?.brand?.code;
  }

  get logoUrl(): string {
    if (this.config?.brand?.logo) {
      return this.config.brand.logo;
    }
      return this.brandCode === 2
    ? this.config.brand.coassess.logo
    : this.config.brand.coreact.logo;
  }

  get logoLogin(): string {
    if (this.config?.brand?.logoLogin) {
      return this.config.brand.logoLogin;
    }
      return this.brandCode === 2
    ? this.config.brand.coassess.logoLogin
    : this.config.brand.coreact.logoLogin;
  }

  get brandName(): string {
    return this.config?.brand?.name || '';
  }

  get favicon(): string {
    return this.config?.brand?.favicon || 'assets/media/logos/coassess-favicon.png';
  }
}
